import { AnimationPlayer } from '@components/AnimationPlayer'
import { Stack, Typography } from '@mui/material'
import React, { FC } from 'react'
import successAnimation from '@assets/lottie/success.json'
import ExchangeReview, { ExchangeViewType } from '@modules/Swap/Components/ExchangeReview'

import type { PlugToken } from '@plug-core/interfaces/common'

interface Props {
  fromToken?: PlugToken
  toToken?: PlugToken
  amount?: string
  receiveAmount?: string
  performMint: () => void
  loading: boolean
  mintSuccess: boolean
  step?: string
  kind: ExchangeViewType
}

const ReviewMint: FC<Props> = ({
  fromToken,
  toToken,
  amount,
  receiveAmount,
  loading,
  performMint,
  mintSuccess,
  step,
  kind,
}) => {
  const content = mintSuccess ? (
    <Stack>
      <Typography variant="h6" textAlign="center" mt={2}>
        Minted Successfully
      </Typography>
      <AnimationPlayer animationData={successAnimation} />
    </Stack>
  ) : (
    <Stack>
      <ExchangeReview
        fromTokenSymbol={fromToken?.symbol}
        toTokenSymbol={toToken?.symbol}
        fromTokenImage={fromToken?.logo}
        toTokenImage={toToken?.logo}
        fromTokenChain={fromToken?.chain}
        toTokenChain={toToken?.chain}
        amount={amount}
        toAmount={receiveAmount}
        kind={kind}
        buttonTitle={`${kind} ${toToken?.symbol}`}
        handleSubmit={performMint}
        loading={loading}
        step={step}
      />
    </Stack>
  )

  return content
}

export default ReviewMint
